export const CONCESSIONS_FEATURE_KEY = 'concessions';
